// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 16:48:01

export default {
  "id": "madness-cars-destroy",
  "slug": "madness-cars-destroy",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/2f5c17b7d11f449c9224f09041d1c312-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/2f5c17b7d11f449c9224f09041d1c312/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Madness Cars Destroy",
      "description": "The game features 6 unique modes:\n\nFunnel: Push cars into the abyss as the funnel narrows!\nRotating Cube: Stay on the spinning cube, which speeds up over time!\nDeadly Arena: Dodge falling bombs and collapsing floors—or shoot players instead!\nRight Color: Inspired by Roblox, but with cars!\nDeadly Bouncers: Avoid spinning mines in a gladiator-style arena!\nHot Potato: Pass the bomb or explode!\nChoose from foreign or Russian cars and dive into the action!",
      "instructions": "Computer controls:  TAB - pause W, A, S, D - control the car on the ground Space - brake  Mobile device controls: Clicking on the touch game buttons on the screen",
      "genres": [
        "Racing & Driving"
      ],
      "tags": [
        "3d",
        "car",
        "destroy",
        "multiplayer",
        "survival"
      ]
    },
    "zh-CN": {
      "title": "疯狂赛车破坏",
      "description": "游戏包含6种独特的模式：\n\n漏斗模式：将汽车推入越来越窄的深渊！\n\n旋转方块模式：保持在旋转的方块上，它会随着时间的推移而加速！\n\n致命竞技场：躲避落下的炸弹和崩塌的地面——或者射击其他玩家！\n\n正确颜色模式：灵感来源于Roblox，但加入了汽车元素！\n\n致命弹跳者模式：在一个角斗士风格的竞技场中避开旋转的陷阱！\n\n热土豆模式：传递炸弹或引爆它！\n\n选择外国或俄罗斯汽车，投入战斗！",
      "instructions": "电脑控制：TAB - 暂停 W, A, S, D - 控制地面上的汽车 空格 - 刹车 移动设备控制：点击屏幕上的触摸游戏按钮",
      "genres": [
        "赛车与驾驶"
      ],
      "tags": [
        "三维",
        "汽车",
        "破坏",
        "多人",
        "生存"
      ]
    },
    "zh-TW": {
      "title": "瘋狂車輛毀滅",
      "description": "遊戲特色包含6種獨特模式：\n\n漏斗模式：將車輛推入縮窄的深渊！\n旋轉立方體：保持在旋轉的立方體上，隨著時間過去速度會變快！\n死亡競技場：躲避墜落的炸彈和崩塌的地板——或者射擊其他玩家！\n正確顏色：受Roblox啟發，但加入了車輛元素！\n致命彈跳兵：在角鬥士風格的競技場中避開旋轉的炸彈！\n熱土豆：傳遞炸彈或引發爆炸！\n從外國或俄羅斯車輛中選擇，並跳入動作中！",
      "instructions": "電腦控制：TAB - 暫停 W, A, S, D - 控制地面上的車輛 空格鍵 - 刹車 行動裝置控制：點擊螢幕上的觸控遊戲按鈕",
      "genres": [
        "賽車與駕駛"
      ],
      "tags": [
        "3D",
        "車輛",
        "毀壞",
        "多人遊戲",
        "生存"
      ]
    },
    "zh-HK": {
      "title": "瘋狂汽車毀滅",
      "description": "遊戲特色6種獨特模式：\n\n漏斗：將車輛推入淵谷，隨著漏斗收窄！\n旋轉立方體：留在旋轉的立方體上，隨著時間加快速度！\n致命賽場：躲避墜落的炸彈和塌陷的地板——或者射擊其他玩家！\n正確顏色：受Roblox啟發，但加入車輛元素！\n致命彈跳者：在角鬥士風格的賽場中避開旋轉的地雷！\n熱土豆：傳遞炸彈或引發爆炸！\n選擇外國或俄羅斯車輛，投入動作之中！",
      "instructions": "電腦操控：TAB - 暂停 W, A, S, D - 控制地面上的車輛 空格鍵 - 刹車 行動裝置操控：點擊螢幕上的觸控遊戲按鈕",
      "genres": [
        "賽車與駕駛"
      ],
      "tags": [
        "3D",
        "汽車",
        "摧毀",
        "多人遊戲",
        "生存"
      ]
    },
    "ja": {
      "title": "狂乱カーズ・デストロイ",
      "description": "このゲームには6つのユニークなモードが特徴です：\n\n・Funnel：漏斗が狭くなるにつれて車を淵に押し込もう！\n・Rotating Cube：回転する立方体に乗り続け、時間が経つにつれて速くなる！\n・Deadly Arena：落下する爆弾や崩れ落ちる床を避け、またはプレイヤーを撃つ！\n・Right Color：Robloxにインスパイアされたものですが、車が登場！\n・Deadly Bouncers：-gladiatorスタイルのアリーナで回転する地雷を避けよう！\n・Hot Potato：爆弾を渡すか、爆発させよう！\n外国車やロシア車から選んで、アクションに飛び込みましょう！",
      "instructions": "コンピュータのコントロール: TAB - ペースト W, A, S, D - 地上の車の操作 Space - ブレーキ モバイルデバイスのコントロール: スクリーンのタッチゲームボタンのクリック",
      "genres": [
        "レーシング&Dライビング"
      ],
      "tags": [
        "3D",
        "車",
        "破壊",
        "マルチプレイヤー",
        "サバイバル"
      ]
    },
    "ko": {
      "title": "혼란 자동차 파괴",
      "description": "게임은 6가지 독특한 모드를 특징으로 합니다:\n\nFunnel: 터널이 좁아지면서 차를渊에 밀어넣어보세요!\nRotating Cube: 회전하는立方체에 머물러 있으며 시간이 지남에 따라 속도가 빨라집니다!\nDeadly Arena: 떨어지는 폭탄과 무너지는 바닥을 피하거나, 대신 플레이어를 쏘세요!\nRight Color: Roblox에서 영감을 받았지만 차로 구현되었습니다!\nDeadly Bouncers: 글래디에이터 스타일의 경기장에서 회전하는 지뢰를 피하세요!\nHot Potato: 폭탄을 넘겨받거나 터트리세요!\n이국적인 차나 러시아 차를 선택하고 행동에 뛰어들세요!",
      "instructions": "컴퓨터 조종: TAB - 일시정지 W, A, S, D - 지면 차량 조종 공백 - 브레이크 모바일 장치 조종: 화면에 있는 탭 게임 버튼을 클릭",
      "genres": [
        "레이싱 & 드라이빙"
      ],
      "tags": [
        "3D",
        "자동차",
        "파괴",
        "멀티플레이어",
        "생존"
      ]
    },
    "fr": {
      "title": "Voitures de folie Destructrices",
      "description": "Le jeu propose 6 modes uniques :\n\nFunnel : Poussez les voitures dans l'abîme tandis que le tronc se rétrécit !\nRotating Cube : Restez sur le cube tournant, qui s'accélère au fil du temps !\nDeadly Arena : Évitez les bombes tombantes et les planchers s'effondrant — ou tirez sur les joueurs à la place !\nRight Color : Inspiré de Roblox, mais avec des voitures !\nDeadly Bouncers : Évitez les mines tournantes dans une arène de gladiateur !\nHot Potato : Transmettez la bombe ou faites exploser !\nChoisissez des voitures étrangères ou russes et plongez dans l'action !",
      "instructions": "Contrôles sur ordinateur : \nTAB - pause\nW, A, S, D - contrôler la voiture au sol\nEspace - freiner\n\nContrôles sur appareil mobile : \nClic sur les boutons de jeu tactiles à l'écran",
      "genres": [
        "Course et conduite"
      ],
      "tags": [
        "3D",
        "voiture",
        "détruire",
        "multijoueur",
        "survie"
      ]
    }
  }
};
